import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

/** Content-shaped loading placeholder. Compose several to mirror the layout
 * that's loading (bars for table rows, tiles for KPI grids) instead of a
 * centered spinner. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("bg-warm-gray-02 animate-pulse rounded-md", className)} {...props} />;
}
